import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingRenewalPayment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/renewal/payment/',
    component: () => import('@/modules/renewal/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/renewal/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
